import React, {useContext, useState} from "react"
import Typography from "../reusable/Typography/Typography"
import WishListProducts from "./WishListProducts"
import WishListContext from "../../context/WishListContext"
import {useTranslation} from "next-i18next"
import {useRouter} from "next/router"
import {X} from "react-bootstrap-icons"
import ToastMessage from "../reusable/ToastMessage"
import MiniPLP from "../home/miniPLP/MiniPLP"
import BikeSuggest from "../reusable/BikeSuggest"
import LayoutContext from "../../context/LayoutContext"
import FirebaseContext from "../../context/FirebaseContext"

function WishListContent() {
	const {t} = useTranslation()
	const router = useRouter()
	const wishListUrl = process.env.NEXT_PUBLIC_APP_URL + router.asPath
	const [toasMessage, setToastMessage] = useState<string>()
	const [showToast, setShowToast] = useState<boolean>(false)
	const {clearWishList, wishList} = useContext(WishListContext)
	const {user} = useContext(FirebaseContext)
	const {isMobile} = useContext(LayoutContext)
	const productsLength = wishList?.length || 0
	const bikesFoundTKey = productsLength === 1 ? "e-bike-found" : "products-found"
	const isWishListOwner = router?.query?.uid === user?.uid || !router?.query?.uid
	return (
		<>
			<main style={{margin: "3rem 0rem"}}>
				<section className="container py-3">
					<Typography variant="bodyLgBlack"
						style={{fontSize: isMobile ? "40px" : "56px", lineHeight: isMobile ? "48px" : "64px"}}
						semanticTag="h1">{t("my-wishlist-label")}</Typography>

					{productsLength ? <><div className="d-flex  justify-content-between align-items-center px-2 py-2">
						<Typography onClick={() => {
							navigator.clipboard.writeText(wishListUrl || t("copy-unsuccessful"))
							setToastMessage(wishListUrl ? t("wishlist-url-shared-label") : t("copy-unsuccessful"))
							setShowToast(() => true)
						}}
						className="d-flex cursor-pointer align-items-center justify-content-start "
						variant="bodySmBold"
						style={{borderRadius: "16px", backgroundColor: "#F8F8F8", fontSize: "14px", lineHeight: "20px", padding: "8px 16px", columnGap: "16px"}}
						semanticTag="span"><img src="/assets/icons/heart-notify.svg"
								style={{width: 20, height: 20}}/> {t("share-wishlist")}</Typography>
						<ToastMessage setShowToast={setShowToast}
							showToast={showToast}
							message={toasMessage}
							state="success"/>
						{isWishListOwner ? <Typography onClick={clearWishList}
							className="d-flex cursor-pointer align-items-center justify-content-start"
							variant="bodySmBold"
							style={{fontSize: "14px", lineHeight: "20px"}}
							semanticTag="span"><X size={24}/> {t("delete-all-label")}</Typography> : null}
					</div>
					<div className="d-flex  justify-content-between align-items-center px-2 pb-4">
						<div
							className={"t-0 pt-2 mb-2 "}>
							<Typography variant={isMobile ? "bodyXSm" : "bodySm"}
								semanticTag="span"
								style={{color: "#6C7074"}}>
								{ `${productsLength} ${t(bikesFoundTKey, {ns: "filters"})}`}
							</Typography>
						</div>
					</div></> : null}
				</section>

				<WishListProducts />
				<MiniPLP />

			</main>
			<BikeSuggest t={t}/>
		</>
	)
}

export default WishListContent
